module.exports = __webpack_public_path__ + "public/Icons/16Completedorders.svg?62d6dc51";